import { addDays, format } from '@querodelivery/qd-date-helper';
import { Text } from '@querodelivery/uni-react';
import type { ENUM_DELIVERY_TYPE } from '@/_features/deliveries/constants';
import {
  EMonitorIndicatorsKey,
  MONITOR_INDICATORS_KEY_BY_DELIVERY_TYPE,
} from '../../constants';
import type { GetMonitorIndicatorsResponse } from '../../types';
import { KpiCard } from './kpi-card';
import styles from './indicators.module.scss';

interface MonitorIndicatorsProps {
  data?: GetMonitorIndicatorsResponse;
  deliveryType?: ENUM_DELIVERY_TYPE;
  isLoading: boolean;
}

export function MonitorIndicators({
  data,
  deliveryType,
  isLoading,
}: MonitorIndicatorsProps) {
  const indicatorsKey = deliveryType
    ? MONITOR_INDICATORS_KEY_BY_DELIVERY_TYPE[deliveryType]
    : EMonitorIndicatorsKey.TOTAL;
  const indicators = data?.[indicatorsKey];
  const yesterday = format(addDays(new Date(), -1), 'dd/MM/yyyy');

  return (
    <section className={styles.section} aria-label="Indicadores">
      <div className={styles.indicators}>
        <KpiCard
          label="Taxa de cancelamento"
          indicator={indicators?.cancellationRate}
          isLoading={isLoading}
          higherIsBetter={false}
        />
        <KpiCard
          label="Quantidade de entregas"
          indicator={indicators?.deliveriesCount}
          isLoading={isLoading}
          higherIsBetter
        />
        <KpiCard
          label="Abaixo de 30 min"
          indicator={indicators?.onTimeDeliveryRate}
          isLoading={isLoading}
          higherIsBetter
        />
      </div>
      <Text as="span" fontSize="xs" fontWeight="medium" tone="supporting">
        Indicadores referentes a ({yesterday})
      </Text>
    </section>
  );
}
